import { render, staticRenderFns } from "./modal_document_category_form.vue?vue&type=template&id=2cd2b26f"
import script from "./modal_document_category_form.vue?vue&type=script&lang=js"
export * from "./modal_document_category_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports